import React from 'react';
import useHomeContext from '@/hooks/useHomeContext';
import Modal from '@/components/Modal';

const AttachmentModal = () => {
  const { attachmentUrl, setAttachmentUrl, attachmentType, setAttachmentType } = useHomeContext()!;

  const handleClose = () => {
    setAttachmentUrl(undefined);
    setAttachmentType(undefined);
  };

  return (
    <Modal
      variant="xl"
      headerVariant="base"
      isOpen={Boolean(attachmentUrl)}
      onClose={handleClose}
      headerText="Attachment">
      <div className="p-4 md:p-5 space-y-4 flex justify-center">
        {attachmentType === 'pdf' ? (
          <embed src={attachmentUrl} type="application/pdf" width="750" height="562.5" />
        ) : (
          <img src={attachmentUrl} crossOrigin="anonymous" />
        )}
      </div>
    </Modal>
  );
};

export default AttachmentModal;
